import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import { useGetPartnerData } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/hooks/useGetPartnerData'
import { useGetPartnerFiles } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/hooks/useGetPartnerFiles'
import { useGetPartnerFlags } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/hooks/useGetPartnerFlags'
import { useEffect, useMemo, useState } from 'react'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { Loader } from 'core-components/library/loader'

import { RequestDetailPartnerForm } from './components/requestDetailPartnerForm/RequestDetailPartnerForm'

export interface IRequestDetailPartnerFormWrapperProps {
  partnerId: string
  onboardingRequestId: number
  appSource: string
  request: IRequest
  disabled?: boolean
}

export const RequestDetailPartnerFormWrapper = ({
  partnerId,
  disabled,
  appSource,
  onboardingRequestId,
  request,
}: IRequestDetailPartnerFormWrapperProps) => {
  const [isForceUpdate, setIsForceUpdate] = useState(true)

  const { options, optionsForPartnerFlags } = useMemo(() => {
    return {
      options: { cacheKey: partnerId, isForce: isForceUpdate },
      optionsForPartnerFlags: {
        cacheKey: partnerId,
        isForce: isForceUpdate,
        paging: { pageSize: 1000, page: 0 },
      },
    }
  }, [isForceUpdate, partnerId])

  const { partnerData, status } = useGetPartnerData(partnerId)
  const { partnerFiles, status: partnerFilesStatus } = useGetPartnerFiles(partnerId, options)
  const { status: partnerFlagsStatus, ...partnerFlags } = useGetPartnerFlags(
    partnerId,
    optionsForPartnerFlags
  )

  useEffect(() => {
    if (partnerData) {
      setIsForceUpdate(false)
    }
  }, [partnerData])

  if (
    status === RequestStatus.PENDING ||
    partnerFilesStatus === RequestStatus.PENDING ||
    partnerFlagsStatus === RequestStatus.PENDING
  ) {
    return <Loader />
  }

  if (!partnerData) {
    return <p>Partner not found</p>
  }

  return (
    <RequestDetailPartnerForm
      partner={partnerData}
      partnerFlags={partnerFlags}
      partnerAttachments={partnerFiles}
      isDisabled={Boolean(disabled)}
      appSource={appSource}
      onboardingRequestId={onboardingRequestId}
      request={request}
    />
  )
}
